import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { prefetchResearcherProject } from './$projectId/-shared';

export const Route = createFileRoute(
  '/researchers/_authenticated/projects/$projectId',
)({
  beforeLoad: async ({ location, params, context }) => {
    // Skip prefetch for 'new' pseudo-ID - no project exists yet
    if (params.projectId === 'new') {
      return;
    }

    // If user navigates to /projects/$projectId directly, redirect to /edit
    if (location.pathname === `/researchers/projects/${params.projectId}`) {
      throw redirect({
        to: '/researchers/projects/$projectId/edit',
        params: { projectId: params.projectId },
      });
    }

    await prefetchResearcherProject(
      context.queryClient,
      params.projectId,
      context.user.id,
    );
  },
  component: ProjectLayout,
});

function ProjectLayout() {
  return <Outlet />;
}
